module.exports = __webpack_public_path__ + "img/four-hands.9d53cd5.jpg";